<template>
  <v-img :src="logoUrl" :alt="configuration.appTitle" :max-width="size" :max-height="size" :width="size" :height="size" cover class="rounded-app" />
</template>

<script>
import { mapState } from "pinia"
import { useConfigurationStore } from "@/store/configuration.js"
import { useUserSessionStore } from "@/store/userSession.js"

export default {
  props: {
    size: {
      type: Number,
      default: 40
    }
  },
  computed: {
    ...mapState(useConfigurationStore, ["configuration"]),
    ...mapState(useUserSessionStore, ["logoUrl"])
  }
}
</script>
